import React, { useEffect } from "react";
import { RangeSwitchPopup } from "../styles";
const RangeModal = ({
  newRange,
  oldRange,
  setCurrentRange,
  clearSelection,
  setRangeModalOpen,
  rangeModalOpen,
  setLimit,
  setSelection,
  limit,
  setIsMini,
  buildBId,
}) => {


  const switchRangeLimits = (newRange) => {
    let isMini = newRange.bundle_name === "MINI_OBJ" ? true : false;
    let nLimit;
    if (isMini) {
      nLimit = limit === 6 ? newRange.box_size.small : newRange.box_size.large;
    } else {
      nLimit = limit === 12 ? newRange.box_size.small : newRange.box_size.large;
    }
    return nLimit;
  };

  const rangeSwitchClear = () => {
    clearSelection();
    setCurrentRange(newRange);
    let t = switchRangeLimits(newRange);
    setLimit(t);
    setRangeModalOpen(!rangeModalOpen);
    setSelection((selection) => {
      let y = [...selection];
      if (y.length < t) {
        while (y.length < t) {
          y.push(null);
        }
      } else if (y.length > t) {
        while (y.length > t) {
          y.pop();
        }
      }
      return y;
    });
    setRangeModalOpen(false);
  };

  const handleClose = () => {
    setIsMini((isMini) => {
      return !isMini;
    });
    setRangeModalOpen(false);
  };

  const rangeSwitchRetain = () => {
    setCurrentRange(newRange);
    let t = switchRangeLimits(newRange);
    setLimit(t);
    setSelection((selection) => {
      let x = [...selection];
      let y = newRange.products;
      let z = x.filter((item) => item !== null);
      let common = [];
      for (let i = 0; i < y.length; i++) {
        for (let j = 0; j < z.length; j++) {
          if (
            y[i].title.toLowerCase().replace(/\smini/gm, "") ===
            z[j].title.toLowerCase().replace(/\smini/gm, "")
          ) {
            // copy so each slot gets its own object and bId (and the catalogue isn't mutated)
            common.push({ ...y[i], random: false, bId: buildBId() });
          }
        }
      }
      if (common.length < t) {
        while (common.length < t) {
          common.push(null);
        }
      } else if (common.length > t) {
        while (common.length > t) {
          common.pop();
        }
      }
      return common;
    });
    setRangeModalOpen(false);
  };

  return (
    <RangeSwitchPopup>
      <div className="inner">
        <span className="modal-close" onClick={handleClose}>
          &times;
        </span>
        <h3>
          You have switched to{" "}
          {newRange.bundle_name === "REG_OBJ" ? "regular" : "mini"} cupcakes.
        </h3>
        <p>
          Would you like to transfer your{" "}
          {oldRange.bundle_name === "REG_OBJ" ? "regular" : "mini"} cupcakes to{" "}
          {newRange.bundle_name === "REG_OBJ" ? "regular" : "mini"}? Please
          note: your {oldRange.bundle_name === "REG_OBJ" ? "regular" : "mini"}{" "}
          choices will be saved if you wish to go back.
        </p>
        <div>
          <button onClick={() => rangeSwitchRetain()}>Yes</button>
          <button onClick={() => rangeSwitchClear()}>No</button>
        </div>
      </div>
    </RangeSwitchPopup>
  );
};

export default RangeModal;
